<template>
  <div>
<!--    <v-combobox-->
<!--        v-model="propsValue"-->
<!--        :items="items"-->
<!--        label="I use chips"-->
<!--        class="tag-input"-->
<!--        multiple-->
<!--        chips-->
<!--    ></v-combobox>-->

    <v-combobox
        v-model="propsValue"
        :items="options"
        :label="placeholder"
        class="tag-input"
        multiple
        chips
    >
      <template v-slot:selection="data">
        <v-chip
            :key="JSON.stringify(data.item)"
            v-bind="data.attrs"
            :input-value="data.selected"
            :disabled="data.disabled"
            @click:close="data.parent.selectItem(data.item)"
        >
<!--          <v-avatar-->
<!--              class="white&#45;&#45;text"-->
<!--              left-->
<!--              v-text="data.item.slice(0, 1).toUpperCase()"-->
<!--          </v-avatar>-->
          {{ data.item }}
        </v-chip>
      </template>
    </v-combobox>

  </div>
</template>

<script>
/**
 <MyTagInput v-model="selected" :options="tags" placeholder="請輸入"></MyTagInput>
 options: [
   'Programming',
   'Design',
   'Vue',
   'Vuetify',
 ],
 **/


export default {
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    placeholder: {
      type: String,
      default() {
        return ""
      }
    },
    options: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data: function () {
    return {
      id: "",
      dataReady: false,
      propsValue: this.value,
      formData: {
        name: "",
      },
      // options: [
      //   'Programming',
      //   'Design',
      //   'Vue',
      //   'Vuetify',
      // ],
    };
  },
  watch: {
    propsValue(newVal) {
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.propsValue = newVal
    }
  },
  methods: {
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
  },
  mounted() {
    //this.loadData()
  },
}
</script>

<style scoped>
.tag-input span.v-chip {
  background-color: #1976d2;
  color: #fff;
  font-size:1em;
  padding-left:7px;
}
</style>
